import React from "react";
import WithTextReadMore from "../WithTextReadMore";
import { FaWhatsapp } from "react-icons/fa";
import { IoLocation } from "react-icons/io5";
import './index.css'
import ButtonPost from "./components/ButtonPost";
import axios from "axios";

const PostCard = ({post})=>{
    const postWithImage = ()=>{
        return(
            <>
        <WithTextReadMore text={post?.descripcion} maxCharacters={100} />
        <div>
            <ButtonPost title={'Enviar Whats'} link={post?.linkMensaje} Icon={<FaWhatsapp style={{width:'30px', height:'30px', color:'green', marginRight:'10px'}} />}/>
            <img style={{objectFit:'contain', width:'100%'}}  src={post?.imgPost} />
            {post?.linkUbicacion && (
                <ButtonPost title={'Ver Ubicacion'} link={post?.linkUbicacion} Icon={<IoLocation style={{width:'30px', height:'30px', color:'blue', marginRight:'10px'}} />} />  
            )} 
        </div>
            </>
        )
    }
    const postWithOutImage = ()=>{
        return (
            <>

            <div>
            <ButtonPost title={'Enviar Whats'} link={post?.linkMensaje} Icon={<FaWhatsapp style={{width:'30px', height:'30px', color:'green', marginRight:'10px'}} />}/>
            <div className="post-card-without-img" >
                <WithTextReadMore bold={true}  size={'24px'} text={post?.descripcion} maxCharacters={300} color="white" />

            </div>
            {post?.linkUbicacion && (
                <ButtonPost title={'Ver Ubicacion'} link={post?.linkUbicacion} Icon={<IoLocation style={{width:'30px', height:'30px', color:'blue', marginRight:'10px'}} />} />  
            )}
            </div>
            </>
        )

    }
    const renderPostCard = ()=>{
        if(post?.imgPost) return postWithImage()
        return postWithOutImage();
    }
    return(                                      
    <div className="post-card-talacha-container">
        {renderPostCard()}                                     
    </div>)
}

export default PostCard